// extracted by mini-css-extract-plugin
export default {"hero":"styles_hero__jJl9r","bottomLeft":"styles_bottomLeft__o-QuZ","topRight":"styles_topRight__go7im","center":"styles_center__aWv1x"};